function initMobileMenu(){
    //Mobi menu
    $('body .hamburger').on('click',function () {
        $('body').toggleClass('mobi-menu-open')
        $(this).toggleClass('is-active')
    })
    if(window.matchMedia('(max-width:1100px)').matches){
        $('#page-header').addClass('fixed');
        $('#main-wrap').css('margin-top',$('.page-header').height() + 'px')
    }

    $(document).on('scrollDown', function () {
        if(window.matchMedia('(max-width:1100px)').matches){
            if ($(window).scrollTop() > 100) {
                $('#page-header').addClass('small');
            }
        }
    });

    $(document).on('scrollUp', function () {
        $('#page-header').removeClass('small');
    });
}